import React from 'react';
import ServiceDetailTemplate from '../components/service/ServiceDetailTemplate';

function CreditoEmpresarial() {
    const data = {
        title: "Crédito Empresarial",
        // Ajustado: /assets/...
        mainImage: "/assets/images/novos/1/1.png",
        description1: "A GB Partner é especializada na estruturação e intermediação de operações financeiras sob medida para empresas de diversos setores.",
        description2: "Atuamos como ponte estratégica entre o seu negócio e o mercado financeiro, garantindo que a estrutura de capital esteja alinhada à realidade e aos objetivos da empresa.",
        cards: [
            { 
                icon: "/assets/images/servicos/3/1.png", 
                title: "Capital de Giro", 
                disc: "Recursos para manter a saúde financeira e a operação do dia a dia." 
            },
            { 
                icon: "/assets/images/servicos/3/1.png", 
                title: "Crédito Estruturado", 
                disc: "Soluções complexas desenhadas para necessidades específicas de captação." 
            },
            { 
                icon: "/assets/images/servicos/3/1.png", 
                title: "Antecipação", 
                disc: "Liquidez imediata através da antecipação de recebíveis e notas fiscais." 
            },
            { 
                icon: "/assets/images/servicos/3/1.png", 
                title: "FIDCs", 
                disc: "Acesso a fundos de investimento em direitos creditórios nacionais e internacionais." 
            }
        ],
        processSteps: [
            { title: "Análise", disc: "Diagnóstico profundo da saúde financeira da empresa." },
            { title: "Estruturação", disc: "Desenho da melhor linha de crédito para o perfil." },
            { title: "Captação", disc: "Conexão com fundos e bancos para liberação do recurso." }
        ],
        benefitTitle: "Diferencial Competitivo",
        benefitDisc: "Por que estruturar seu crédito com a GB Partner?",
        benefits: [
            "Acesso a Mercado de Capitais",
            "Operações com fundos internacionais",
            "Taxas competitivas e prazos adequados",
            "Consultoria técnica em toda a jornada"
        ]
    };

    return <ServiceDetailTemplate {...data} />;
}

export default CreditoEmpresarial;